import React, { ReactElement, useState } from 'react'

import { Box, Flex, Icon, VStack, useMediaQuery } from '@chakra-ui/react'
import { deviceMin } from '@helpers/mediaQueryBreakpoints'
import { capsFirst } from '@helpers/stringUtilities'
import { MdRadioButtonChecked, MdRadioButtonUnchecked } from 'react-icons/md'
import { Link } from 'react-scroll'

interface MenuStickyProps {
    children: ReactElement[]
}

const MenuSticky = ({ children }: MenuStickyProps) => {
    const [current, setCurrent] = useState('')
    const [isDesktop, isXlDesktop, isXXLDesktop] = useMediaQuery([deviceMin.lg, deviceMin['2xl'], deviceMin['3xl']])
    const screenOffset = isXXLDesktop ? -700 : isXlDesktop ? -450 : isDesktop ? -220 : -60

    const handleSetActive = (to: string) => {
        setCurrent(to)
    }

    return (
        <Box>
            <VStack
                display={isDesktop ? 'flex' : 'none'}
                position="fixed"
                right="0"
                top="0"
                pr="6"
                h="100%"
                justify="center"
                gap="4"
                zIndex={2}
            >
                {children
                    ?.map((child, index) => {
                        const isLast = index === children.length - 1
                        return { id: child?.props?.id, name: child?.props?.name, isLast: isLast }
                    })
                    ?.map(
                        ({ id, name, isLast }) =>
                            id &&
                            name && (
                                <Flex
                                    key={id}
                                    w="100%"
                                    justify="end"
                                    align="center"
                                    cursor="pointer"
                                    color={id === current ? 'green.500' : 'indigo.300'}
                                    fontSize="12px"
                                    fontWeight="bold"
                                >
                                    <Link
                                        activeClass="active"
                                        smooth
                                        spy
                                        to={id}
                                        duration={500}
                                        width="100%"
                                        onSetActive={handleSetActive}
                                        offset={isLast ? screenOffset : -60}
                                    >
                                        <Flex gap="3" align="center">
                                            {capsFirst(name)}

                                            <Icon
                                                as={id === current ? MdRadioButtonChecked : MdRadioButtonUnchecked}
                                                color="inherit"
                                                w={5}
                                                h={5}
                                            />
                                        </Flex>
                                    </Link>
                                </Flex>
                            )
                    )}
            </VStack>

            {children}
        </Box>
    )
}

export default MenuSticky
